module.exports = __webpack_public_path__ + "static/media/destination_santorini.a270d53a.jpg";